export default class DebitTypeList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/debit_type/list')

		return new DebitTypeList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
